const audio = new Audio(`${process.env.SERVICE_STATIC}/lisa/audios/lisa-message-01.mp3`);

export const audioNotification = () => audio.play().catch(() => {});
